import { useAppContext } from '../../components/app-factory/context';

export const useStaticUrls = () => useAppContext().staticUrls;
